module.exports = __webpack_public_path__ + "img/member05.d98393df.png";